// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '../static/element-#FF9E74/index.css';
import './assets/animate.min.css';
import axios from 'axios';
Vue.prototype.$axios = axios;
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();

Vue.use(ElementUI);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js